import React from 'react'

export const Header = (): JSX.Element => <div>ספריית הווידאו</div>
